var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-trend-chart"},[_vm._t("ariaTitle"),_vm._l((_vm.spread),function(cssClass,i){return _c('div',{key:i,class:cssClass})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }